<template>
  <div class="language">
    <label for="language-select" class="gb-text-base">
      <i class="fa fa-globe" aria-hidden="true"/> Assessment Language: </label>
    <span v-if="languages.length === 1">{{ languages[0] | capitalize }}</span>
    <A11y-Dropdown
      v-else
      :dropdown-props="{
        ref:'languageDropdown'
      }"
      :button-props="{
        type:'button',
        class:'btn btn-sm btn-gb-light dropdown-toggle',
        role:'combobox',
        'aria-haspopup':'listbox',
        id:'language-dropdown-button-'+htmlId,
        'aria-controls':'language-dropdown-menu-'+htmlId,
        'aria-label':'Select resource language'
      }"
      :dom-attributes="{
        role:'listbox',
        id:'language-dropdown-menu-'+htmlId
      }"
      @openedDropdown="changedLanguage"
    >
      <template slot="button-contents">
        {{ displayLanguage | capitalize }}
        <span class="caret"/>
      </template>
      <template slot="dropdown-items">
        <li
          v-for="language in languages"
          :key="language"><a role="button" @click="selectLanguage(language)">{{ language | capitalize }}</a></li>
      </template>
    </A11y-Dropdown>
  </div>
</template>

<script>
import A11yDropdown from '@/components/A11yDropdown'
import { mapGetters, mapMutations } from 'vuex'

export default {
    name: 'ResourceLanguageDropdown',
    props: {
      objectId: {
        type: String,
        required: true
      },
    },
    components: {
        A11yDropdown
    },
    data() {
      return {
        htmlId: 'resource-language-dropdown-' + this._uid
      }
    },
    computed: {
      ...mapGetters('goaldetail', [
        'languagesById',
        'selectedLanguageById'
      ]),
      languages() {
        return this.languagesById(this.objectId) || []
      },
      displayLanguage() {
        return this.selectedLanguageById(this.objectId) || (this.languages.length > 0 ? this.languages[0] : '')
      }
    },
    methods: {
      ...mapMutations('goaldetail', ['setSelectedLanguage']),
      changedLanguage() {
        this.$sendEvent('Clicked Change Resource Language')
      },
      selectLanguage(language) {
        this.setSelectedLanguage({ contentId: this.objectId, language })
      }
    }
}

</script>
<style lang="less" scoped>
@import '~bootstrap/less/mixins/buttons';
@import '~@/variables.less';
.language {
  line-height: 16px;
}

label {
  font-weight: normal;
  margin: 0px 6px 0px 6px;
  i, span {
    color: rgb(140, 140, 140);
  }
  span {
    margin-right: 1px;
    margin-left: 2px;
    vertical-align: text-top;
  }
}
/deep/ .btn-gb-light {
  .button-variant(#636363, white, rgb(140, 140, 140));
}
</style>